import { SxProps } from '@mui/material';
import TextInput from '@shared/components/TextInput';

type Props = {
  label: string;
  value: string;
  onClick?: () => void;
  sx?: SxProps;
  latency?: string;
};

export const TextInputReadOnlyBox: React.FC<Props> = ({ label, value, onClick, sx, latency }) => {
  return (
    <TextInput
      label={label}
      inputProps={{
        name: label,
        readOnly: true,
        value,
      }}
      onClick={onClick}
      sx={{
        height: 'fit-content',
        paddingTop: '8px',
        ...sx,
      }}
      latency={latency}
    />
  );
};
